<template>
  <PanelV2
    type="w7"
    mode="simple"
  >
    <template v-slot:content-solt>
      <img src="@/assets/pc/Icon - Success@2x.png" />
      <span class="title">You've successfully changed your password</span>
      <span class="sub-title">You can now use your new password to log in.</span>
      <el-button type="primary" @click="toIndex()">Go back to Login</el-button>
    </template>
  </PanelV2>
</template>

<script>
  export default {
    name: 'ChangePasswordDone',
    pRouter: 'ChangePassword',
    data() {
      return {
      }
    },
    methods: {
      toIndex () {
        this.$router.push({path: '/check-mid-process'});
      }
    }
  }
</script>


<style lang="scss" scoped>
  .panel-v2 {
    height: 561px;
    text-align: center;

    img {
      margin: 32px 0 0;
      width: 120px;
    }

    .title {
      margin: 32px 0 0;
      font: normal normal normal 24px/40px Nunito-bold;
      letter-spacing: 0px;
      color: #2E2E2E;
    }

    .sub-title {
      margin: 16px 0 0;
      font: normal normal normal 16px/24px Nunito;
      letter-spacing: 0px;
      color: #2E2E2E;
    }

    .el-button {
      margin: 143px 0 0;
      width: 318px;
    }
  }

</style>
